import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faBars, faUser, faHome, faHouseUser, faLock, faSignOutAlt, faCog, faArrowAltCircleRight, faFilePdf, faSpinner, faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faEdit, faUserEdit, faTimes, faSave, faSquare, faCheckSquare, faCheckCircle, faEnvelopeSquare, faEnvelope, faEnvelopeOpen
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub, faFacebook, faFacebookSquare, faFacebookMessenger, faGoogle, faGooglePlus, faGooglePlusG, faWhatsapp, faWhatsappSquare, faTwitter, faTwitterSquare
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faBars,
  faUser, faHome, faHouseUser, faLock, faSignOutAlt, faCog, faGithub, faArrowAltCircleRight, faFilePdf, faSpinner, faChevronRight, faWhatsapp, faWhatsappSquare, faTwitter, faTwitterSquare,
  faChevronLeft, faChevronUp, faChevronDown, faEdit, faUserEdit, faTimes, faSave, faFacebook, faFacebookMessenger,
  faFacebookSquare, faGoogle, faGooglePlus, faGooglePlusG, faSquare, faCheckSquare, faCheckCircle, faEnvelopeSquare, faEnvelope, faEnvelopeOpen
)

Vue.component('Fa', FontAwesomeIcon)
